const toast = {
    custom({ message, title, type, duration = 3000 }) {
        let container = document.querySelector(".sa-toast-container");
        if (!container) {
            container = document.createElement("div");
            container.className = "sa-toast-container";
            document.body.appendChild(container);
        }

        const el = document.createElement("div");
        el.className = `sa-toast ${type}`;
        el.innerHTML = `<strong>${title}</strong><div>${message}</div>`;

        container.appendChild(el);

        setTimeout(() => {
            el.classList.add("fade-out");
            setTimeout(() => el.remove(), 500);
        }, duration);
    },
    success(msg, title = "Successo!") {
        this.custom({ message: msg, title, type: "success" });
    },
    info(msg, title = "Info") {
        this.custom({ message: msg, title, type: "info" });
    },
    error(msg, title = "Errore") {
        this.custom({ message: msg, title, type: "danger" });
    },
    warning(msg, title = "Attenzione") {
        this.custom({ message: msg, title, type: "warning" });
    },
    validation({ msg = null, esito = false, sezione = null }) {
        if (!sezione) {
            sezione = "Attenzione !";
        }
        if (!esito) {
            const messages = msg
                .split("#")
                .map((m) => m.trim())
                .filter((m) => m !== "");
            console.log(messages);
            let htmlContent = "";
            if (messages.length > 1) {
                htmlContent = `<ul style="margin-left: 15px; margin-top: 5px; padding: 0;">`;
                messages.forEach((text) => {
                    htmlContent += `<li>${text}</li>`;
                });
                htmlContent += `</ul>`;
            } else if (messages.length === 1) {
                htmlContent = `<li>${messages[0]}</li>`;
            }
            this.custom({
                message: htmlContent,
                title: sezione || "Attenzione!",
                type: "danger",
                duration: 5000,
            });
        }
    },
};

export default toast;
